<template>
  <div class="prize">
    <i class="back" @click="back"></i>
    <p class="title">
      <span class="left line"></span>
      <span class="word">恭喜你获得了</span>
      <span class="right line"></span>
    </p>
    <div class="prizebox">
      <img :src="prizeImg.img" />
      <p>
        <i></i>
        <span>{{prizeImg.name}}</span>
        <i></i>
      </p>
    </div>
    <div class="word">
      <p v-for="(item,index) in prizeImg.mes" :key="index">{{item}}</p>
    </div>
    <p class="btn" @click="back">好的</p>
  </div>
</template>

<script>
import utils from "@/assets/js/utils";
import ajax from "@/api/ajax";
import prize_a1 from "@/assets/images/parent_active/prize/prize_a1.png";
import prize_a2 from "@/assets/images/parent_active/prize/prize_a2.png";
import prize_a3 from "@/assets/images/parent_active/prize/prize_a3.png";
import prize_b1 from "@/assets/images/parent_active/prize/prize_b1.png";
import prize_b2 from "@/assets/images/parent_active/prize/prize_b2.png";
import prize_b3 from "@/assets/images/parent_active/prize/prize_b3.png";
import prize_c1 from "@/assets/images/parent_active/prize/prize_c1.png";
import prize_c2 from "@/assets/images/parent_active/prize/prize_c2.png";
import prize_c3 from "@/assets/images/parent_active/prize/prize_c3.png";
const prizeMes = {
  a1: {
    name: "金币大宝箱",
    img: prize_a1,
    mes: { 0: "500金币已经发放至作业盒子的账号" }
  },
  a2: {
    name: "布克⻢克杯",
    img: prize_a2,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  },
  a3: {
    name: "布克雨伞",
    img: prize_a3,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  },
  b1: {
    name: "积分大宝箱",
    img: prize_b1,
    mes: { 0: "100积分已经发放至作业盒子的账号" }
  },
  b2: {
    name: "布克皮革笔记本",
    img: prize_b2,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  },
  b3: {
    name: "布克笔袋",
    img: prize_b3,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  },
  c1: {
    name: "布克听世界3节",
    img: prize_c1,
    mes: { 0: "3节课程已经放在了家⻓盒子的学习中心", 1: "刷新后即可收听呦~" }
  },
  c2: {
    name: "布克印章",
    img: prize_c2,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  },
  c3: {
    name: "布克/莉克毛绒公仔",
    img: prize_c3,
    mes: {
      0: "官方工作人员将在3个工作日内给您",
      1: "打电话确认收货地址",
      2: "在14个工作日内通过快递发放奖励"
    }
  }
};
export default {
  name: "prize",
  data() {
    return {
      prizeImg: ""
    };
  },
  methods: {
    back: function() {
      let url = "hybird://method/exit";
      location.href = url;
    },
    flush: async function() {
      let url = "hybird://method/onNoticationNativiePage?type=1";
      location.href = url;
    }
  },
  created: async function() {
    let self = this;
    let token = utils.getQueryString("token");
    let recordId = utils.getQueryString("recordId");
    const [resp] = await ajax.all([
      ajax.post("/html5/common-act/update-box-award-status", {
        token: token,
        recordId: recordId
      })
    ]);
    if (resp.data.code == 99999) {
      this.prizeImg = prizeMes[resp.data.data.awardFlag];
      await self.flush();
    }
  }
};
</script>

<style lang="scss" scoped>
.prize {
  background-color: #fff;
  min-height: 100vh;
  padding-top: 2.3rem;
  .back {
    position: absolute;
    top: 0.26rem;
    left: 0.38rem;
    width: 0.2rem;
    height: 0.34rem;
    background: url("../../assets/images/parent_active/prize/back_icon.png") 0 0 /
      cover no-repeat;
  }
  /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.26rem+ constant(safe-area-inset-top));
      top: calc(0.26rem+ env(safe-area-inset-top));
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .back {
      top: calc(0.26rem+ constant(safe-area-inset-top));
      top: calc(0.26rem+ env(safe-area-inset-top));
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: 0.8rem;
    }
  }
  .title {
    text-align: center;
    margin-top: 0.5rem;
    .line {
      margin-bottom: 0.15rem;
      display: inline-block;
      width: 1.1rem;
      height: 2px;
      border-radius: 2px;
    }
    .left {
      background-image: linear-gradient(
        to right,
        rgba(243, 222, 201, 0) 0%,
        rgba(243, 222, 201, 0.5) 32%,
        #f3dec9
      );
    }
    .right {
      background-image: linear-gradient(
        to right,
        #f3dec9 0%,
        rgba(243, 222, 201, 0.5) 32%,
        rgba(243, 222, 201, 0)
      );
    }
    .word {
      padding: 0 0.32rem;
      font-family: PingFangSC-Medium;
      font-size: 0.46rem;
      color: #b37f51;
    }
  }
  .prizebox {
    margin: 1.1rem auto 0.6rem;
    width: 5.7rem;
    height: 4.3rem;
    background-color: #f5f6f8;
    border-radius: 0.3rem;
    border: solid 1px #f5f6f8;
    text-align: center;
    img {
      width: 4.5rem;
      height: 2.9rem;
    }
    p {
      font-family: PingFangSC-Medium;
      font-size: 0.44rem;
      line-height: 0.48rem;
      color: #f5833c;
      i {
        display: inline-block;
        width: 0.08rem;
        height: 0.08rem;
        background-color: #9ea2b8;
        opacity: 0.4;
        border-radius: 4px;
        margin-bottom: 4px;
      }
      span {
        margin: 0 0.2rem;
      }
    }
  }
  .word {
    margin: 0 auto 1.3rem;
    height: 1.1rem;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #9ea2b7;
    text-align: center;
  }
  .btn {
    margin: 0 auto;
    width: 5.8rem;
    height: 1rem;
    background-color: #e7be84;
    border-radius: 0.5rem;
    font-family: PingFangSC-Semibold;
    font-size: 0.34rem;
    line-height: 1rem;
    color: #ffffff;
    text-align: center;
  }
}

/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .prize {
    padding-top: calc(2.3rem + constant(safe-area-inset-top));
    padding-top: calc(2.3rem + env(safe-area-inset-top));
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .prize {
    padding-top: calc(2.3rem + constant(safe-area-inset-top));
    padding-top: calc(2.3rem + env(safe-area-inset-top));
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .prize {
    padding-top: calc(2.3rem + constant(safe-area-inset-top));
    padding-top: calc(2.3rem + env(safe-area-inset-top));
  }
}
</style>
